/**
 * Price Quantity Component
 *
 * @module price-quantity
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = "price-quantity";

if (!customElements.get(customElements.component)) {
  class priceQuantity extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.static) return;

      this.value = 1;
      this.baseApiUrl =
        "https://api.boldcommerce.com/go_pre/pricerules/0ccab2.myshopify.com";
      this.handle = this.dataset.handle;
      this.quantityBreaks = [];
      this.placement = this.dataset.placement;

      window.theme.product.loadProduct(this.handle).then((product) => {
        this.product = product;
        this.message = this.dataset.message;
        this.loadPriceQuantityBox();
        this.listenToVariantChange();
      });
    }

    connectedCallback() {
      window.addEventListener(
        `quantity-changed-${this.handle}`,
        this.handleQuantityChanged.bind(this)
      );
    }

    disconnectedCallback() {
      window.removeEventListener(
        `quantity-changed-${this.handle}`,
        this.handleQuantityChanged.bind(this)
      );
    }

    handleQuantityChanged(event) {
      // You can access someParameter and event here
      this.value = +event.detail.value;

      this.updatePricing(this.value);
    }

    updatePricing(value) {
      let found = this.priceBreaks.find((item) => value >= item.minQuantity);
      let elem = this.closest("form").querySelectorAll("[data-price]");
      let priceComparedElements = this.closest("form").querySelectorAll("addtocart-button [data-price-compared]");

      if (priceComparedElements.length) {
        priceComparedElements.forEach((item) => {
          if (!item.dataset.amount) {return}

          if (value === 0 || value === 1) {
            item.innerHTML = item.dataset.amount;
          } else {
            const currency = item.dataset.amount.slice(0, 1);
            const total = item.dataset.amount.slice(1) * value;
            item.innerText = `${currency}${total.toFixed(2)}`;
          }
        });
      }

      if (found && elem && elem.length) {
        elem.forEach((item) => {
          if (item.dataset.total === "true") {
            const currency = found.price.slice(0, 1);
            const total = found.price.slice(1) * value;
            item.innerText = `${currency}${total.toFixed(2)}`;
          } else {
            item.innerText = found.price;
          }
        });
        elem.innerText = found.price;
      }
    }

    listenToVariantChange() {
      this.variantSelector = this.closest("component-addtocart").querySelector(
        "variant-selector"
      );
      if (!this.variantSelector) return;

      this.variantSelector.addEventListener("variant-change", (event) => {
        if (!event.detail.variantId) return;
        setTimeout(() => {
          this.createBoxTemplate(event.detail.variantId);
          this.createPricingBreaks(event.detail.variantId);
          this.updatePricing(this.value);
        }, 0);
      });
    }

    async loadPriceQuantityBox() {
      try {
        const url = `${this.baseApiUrl}/rulesets?products=${this.dataset.productId}`;
        const response = await fetch(url);
        const data = await response.json();

        if (data.rulesets.length) {
          this.rulesSets = data.rulesets.map((ruleset) => {
            return {
              variantId: ruleset.product_selection.products[0].variant_id,
              rules: ruleset.rules.filter((rule) => rule.type === "DISPLAY"),
            };
          });
          this.createBoxTemplate(this.product.variants[0].id);
          this.createPricingBreaks(this.product.variants[0].id);
        }
      } catch (error) {
        console.error("Error catching rulesets:", error);
      }
    }

    createBoxTemplate(variantId) {
      if (!variantId) return;
      const metafields = this.product.variants_metafields[0]?.metafields;
      let minPackQty = metafields?.min_pack_qty || "";

      const message =
        this.placement === "product-card" || this.placement === "product-card-collection"
          ? "Price per case"
          : "Bulk price per case";

      if (!this.rulesSets) {return ''}
      const ruleset = this.rulesSets.find((ruleset) => ruleset.variantId == variantId);

      if (!ruleset) {
        console.log(`Missing ruleset for variant ${variantId}`);
        this.innerHTML = '';
        return '';
      }

      let args = {
        message: message,
        ruleset: ruleset,
        variantId: variantId,
        minPackQty: minPackQty
      }

      //console.log('rulesSets:', this.rulesSets);
      //console.log('args:', args);

      let boxTemplate = this.createPriceQuantityWrapper(args);
      this.innerHTML = boxTemplate;
    }

    createPriceQuantityWrapper(args) {
      if (!this.placement || !args) {return ''}

      switch (this.placement) {
        case "product-single":
          return `
          <div data-price-quantity class="price-quantity-wrapper bg-[#FBFBFB] rounded-[5px]">
            <div class="text-secondary font-bold px-[10px] py-1 rounded-tl-[5px] rounded-tr-[5px] w-full bg-[#EBEBEB] overflow-hidden mb-1 font-primary text-base uppercase">${args.message}:</div>
            
            <div class="grid items-center gap-y-2 gap-x-2 border-b-[1px] border-[#EBEBEB] last:border-b-0 px-[10px] py-1" style="grid-template-columns: max-content max-content 1fr;">
              ${this.createItemsTemplate(args.variantId)}
            </div>
          </div>
          `;
        case "product-card":
          return `
          <div data-price-quantity class="price-quantity-wrapper">
            <div style="text-black font-bold font-size: 12px;" class="px-[10px] w-full overflow-hidden mb-1 font-primary uppercase font-bold">${args.message}:</div>
            
            <div class="grid items-center gap-x-2 border-b-[1px] border-[#EBEBEB] last:border-b-0 px-[10px] py-1" style="grid-template-columns: max-content max-content 1fr">
              ${this.createItemsTemplate(args.variantId)}
            </div>
          </div>
          `;
        case "product-card-collection":
          return `
          <div data-price-quantity class="price-quantity-wrapper">
            <div style="text-black font-bold font-size: 12px;" class="px-[10px] w-full overflow-hidden mb-1 font-primary uppercase font-bold">${args.message}:</div>
            
            <div class="grid items-center gap-x-2 border-b-[1px] border-[#EBEBEB] last:border-b-0 px-[10px] py-1" style="grid-template-columns: max-content max-content 1fr;">
              ${this.createItemsTemplate(args.variantId)}
            </div>
          </div>
          `;
        default:
          return '';
      }
    }

    createPricingBreaks(variantId) {
      const variant = this.product.variants.find(
        (variant) => variant.id == variantId
      );

      this.priceBreaks = this.quantityBreaks
        .sort((a, b) => b.qty - a.qty)
        .map((quantityBreak) => ({
          minQuantity: quantityBreak.qty,
          price: theme.money.format(quantityBreak.price),
        }));
      this.priceBreaks.push({
        minQuantity: 1,
        price: theme.money.format(variant.price),
      });
    }

    createItemsTemplate(variantId) {
      const variant = this.product.variants.find(
        (variant) => variant.id == variantId
      );

      const ruleset = this.rulesSets.find(
        (ruleset) => ruleset.variantId == variantId
      );

      if (!ruleset) {
        console.log(`Missing ruleset for variant ${variantId}`);
        return "";
      }

      this.quantityBreaks = this.getQuantityBreaks(ruleset);

      let itemsTemplate = "";
      let minQty = 1;
      let currentPrice = variant.price;
      const variantFound = this.product.variants_metafields.find(
        ({ variant_id }) => variant_id == variantId
      );
      const variantCaseQty = (variantFound?.metafields?.min_pack_qty ?? "")
        .match(/\d+/g)
        ?.join("");

      this.quantityBreaks.forEach((element) => {
        itemsTemplate += this.getIntervalTemplate(
          minQty,
          element.qty - 1,
          theme.money.format(currentPrice),
          `${minQty} - ${element.qty - 1}`,
          variantCaseQty && !Number.isNaN(variantCaseQty)
            ? `${theme.money.format(currentPrice / variantCaseQty)} per unit`
            : null,
          currentPrice == variant.price
            ? ""
            : this.getDiscountTemplate(variant.price, currentPrice)
        );
        currentPrice = element.price;
        minQty = element.qty;
      });

      currentPrice = this.quantityBreaks[this.quantityBreaks.length - 1].price;
      // final price
      itemsTemplate += this.getIntervalTemplate(
        minQty,
        99999999,
        theme.money.format(
          this.quantityBreaks[this.quantityBreaks.length - 1].price
        ),
        `${minQty}+`,
        variantCaseQty && !Number.isNaN(variantCaseQty)
          ? `${theme.money.format(currentPrice / variantCaseQty)} per unit`
          : null,
        currentPrice == variant.price
          ? ""
          : this.getDiscountTemplate(variant.price, currentPrice)
      );

      return itemsTemplate;
    }

    getDiscountTemplate(mainPrice, discountedPrice) {
      const percentageOff = 100 - (discountedPrice * 100) / mainPrice;
      return `${percentageOff.toFixed(2)}% OFF`;
    }

    getQuantityBreaks(ruleset) {
      const quantityBreaks = [];
      ruleset.rules.forEach((rule) => {
        rule.actions.forEach((action) => {
          if (action.type === "DISPLAY_QTY_BREAK") {
            quantityBreaks.push(action);
          }
        });
      });

      return quantityBreaks;
    }

    getIntervalTemplate(
      minQty,
      maxQty,
      price,
      displayText,
      perUnit = null,
      percentageOff = null
    ) {
      return this.placement === "product-card"
        ? `
          <div class="flex gap-2 items-center justify-between" style="min-height: 22px; font-weight: 700; font-size: 12px; line-height: 12px;">
            <div class="data-interval" data-min="${minQty}" data-max="${maxQty}">${displayText}</div>
            <div>Cases:</div>
          </div>
          <div style="font-size: 12px; line-height: 12px; font-weight: 700;">${price}</div>
          <div class="flex gap-4 items-center">
            ${
              perUnit
                ? `<div style="letter-spacing: 0.01em; line-height: 10px; font-size: 10px; font-weight: 300; color: #494949">/ ${perUnit}</div>`
                : ""
            }
            ${
              percentageOff
                ? `<div style="font-size: 8px; line-height: 8px;" class="flex justify-center items-center text-white bg-[#2158AA] px-2 py-1 rounded-sm font-primary font-bold text-nowrap">${percentageOff}</div>`
                : ""
            }
          </div>
      `
        : this.placement === "product-card-collection"
        ? `
          <div class="flex !flex-row gap-2 items-center justify-between price-breakdown-collection-card-text">
            <div class="data-interval" data-min="${minQty}" data-max="${maxQty}">${displayText}</div>
            <div>Cases:</div>
          </div>
          <div class="flex !flex-row items-center price-breakdown-collection-card-text">${price}</div>
          <div class="flex !flex-row gap-2 items-center">
            ${
              perUnit
                ? `<div class="price-breakdown-collection-card-text-unit">/ ${perUnit}</div>`
                : ""
            }
            ${
              percentageOff
                ? `<div class="price-breakdown-collection-card-emblem flex justify-center items-center text-white bg-[#2158AA] px-2 py-1 rounded-sm font-primary font-bold text-nowrap">${percentageOff}</div>`
                : ""
            }
          </div>
        `
        : `
          <div class="flex gap-2 items-center justify-between" style="min-height: 22px; font-weight: 700; font-size: 14px; line-height: 14px;">
            <div class="data-interval" data-min="${minQty}" data-max="${maxQty}">${displayText}</div>
            <div>Cases:</div>
          </div>
          <div style="font-size: 14px; line-height: 14px; font-weight: 700;">${price}</div>
          <div class="flex gap-4 items-center">
            ${
              perUnit
                ? `<div style="letter-spacing: 0.01em; line-height: 14px; font-size: 14px; font-weight: 300; color: #494949">/ ${perUnit}</div>`
                : ""
            }
            ${
              percentageOff
                ? `<div style="font-size: 8px; line-height: 8px;" class="flex flex-nowrap justify-center items-center text-white bg-[#2158AA] p-2 rounded-sm font-primary font-bold">${percentageOff}</div>`
                : ""
            }
          </div>
      `;
    }
  }
  customElements.define(customElements.component, priceQuantity);
}
